<!--仓库发起采购页面-->
<template>
  <el-dialog
    :title="getTitle()"
    :visible.sync="dialogSeeVisible"
    center
    :close-on-click-modal="false" :append-to-body="true"
    custom-class="max-dialog1256">
    <div ref="print1" style="width:98%;margin: 0 auto;">
      <p :style="{display:showtitle1,textAlign:'center',fontSize:'18px',lineHeight:'40px'}">{{getTitle()}}</p>
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;"
             class="query-table">
        <tr class="noborder">
          <td align="right" width="60">入&nbsp;&nbsp;&nbsp;&nbsp;库：</td>
          <td width="120">
            <el-select v-model="controlData.cangkucode" placeholder="请选择" size="mini" @change="changename">
              <el-option
                v-for="item in jxcstoreData"
                :key="item.cangkucode"
                :label="item.cangkuname"
                :value="item.cangkucode">
              </el-option>
            </el-select>
          </td>
          <td align="right" width="70">产&nbsp;&nbsp;品&nbsp;&nbsp;名：</td>
          <td>
            <CommonTree ref="treeSeed" :inputSize="'mini'" :defineDataSource="true" @bindData="bindData"
                        :isShowCheckBox="false" :treeWidth="550"
                        :treeHeight="500" :searchText="form.seedname"
                        @check="checktree1"></CommonTree>
          </td>
          <td>
            <el-button type="primary" @click="initnum" size="mini" v-if="intelligentstore&&!IsBack">一键补货</el-button>
          </td>
          <td>
            编码:{{form.seedcode}}
          </td>
        </tr>
        <tr class="noborder" v-if="false">
          <td align="right">订单号：</td>
          <td>系统自动生成</td>
          <td align="right">时&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;间：</td>
          <td>{{controlData.adddate}}</td>
        </tr>
        <tr class="noborder">
          <td align="right" width="60">供应商：</td>
          <td colspan="3">
            <el-select v-model="controlData.pcustomerserial" placeholder="请选择" size="mini" @change="changepcu" style="width: 60%">
              <el-option
                v-for="item in ptableData"
                :key="item.customerserial"
                :label="item.deptname"
                :value="item.customerserial">
              </el-option>
            </el-select>
            <el-checkbox v-model="isgift" v-if="!IsBack">赠送的商品</el-checkbox>
            <el-input style="width: 130px; margin-left: 10px;" size="mini" v-model="scanpowercode"
                      ref="scanpowerInput" onfocus="this.select()" placeholder="扫光度码" @change="scanPowerCode()"></el-input>
            <el-radio-group v-model="isRightStr" v-if="!IsBack&&filltemplate == '20'&&ssotoken" style="margin-left: 20px">
              <el-radio :label="''">随机</el-radio>
              <el-radio :label="'Right'">右眼</el-radio>
              <el-radio :label="'Left'">左眼</el-radio>
            </el-radio-group>
          </td>
          <td align="right" width="60"></td>
          <td width="140">
            <!--{{controlData.clinkman!=null ||-->
            <!--controlData.clinkmantel!=null?controlData.clinkman+controlData.clinkmantel:" "}}-->
          </td>
        </tr>
        <tr class="noborder" v-if="!IsBack">
          <td align="right"  v-if="!ssotoken">供应号：</td>
          <td width="140"  v-if="!ssotoken">
            <el-input v-model="tracknum" size="mini" ref="tracknum" placeholder="请输入供应商单号" onfocus="this.select()"></el-input>
          </td>
          <td align="right">跟踪号：</td>
          <td width="140">
            <el-input v-model="logisticstracknum" size="mini" ref="logisticstracknum" placeholder="请填写跟踪单号" onfocus="this.select()"></el-input>
          </td>
          <td align="right"><span v-if="ADDlist.length>0">ADD:</span></td>
          <td>
            <el-select  v-if="ADDlist.length>0" v-model="ADDString" size="mini" @change="selectADD">
            <el-option v-for="o in ADDlist" :key="o" :label="o" :value="o"></el-option>
          </el-select>
          </td>
        </tr>
        <!--<tr class="noborder">-->
        <!--<td align="right">收货方：</td>-->
        <!--<td width="140">{{controlData.servedname}}</td>-->
        <!--<td align="right">收货地址：</td>-->
        <!--<td width="220">{{controlData.address}}</td>-->
        <!--<td align="right">联系人：</td>-->
        <!--<td width="140">{{controlData.linkman +controlData.linkmantel}}</td>-->
        <!--</tr>-->
        <tr class="noborder" v-show="showerweitable">
          <td colspan="6">
            <TwoDimensionalTable ref="referweibiao" :cutHeight="311" :positive="true" :erweitable="erweitable"   @afterChange="afterChange"></TwoDimensionalTable>
          </td>
        </tr>
        <tr v-show="showzuoyoutable">
          <td colspan="6" style="border:none">
            <el-col :span="2" style="text-align: right">右眼：</el-col>
            <el-col :span="10">
              <TwoDimensionalTable ref="referweibiaoright" :cutHeight="311" :positive="true" :erweitable="erweitableright" @afterChange="afterChangeRight"></TwoDimensionalTable>
            </el-col>
            <el-col :span="2" style="text-align: right">左眼：</el-col>
            <el-col :span="10">
              <TwoDimensionalTable ref="referweibiaoleft" :cutHeight="311" :positive="true" :erweitable="erweitableleft" @afterChange="afterChangeLeft"></TwoDimensionalTable>
            </el-col>
          </td>
        </tr>
        <tr class="noborder" v-show="showNumberSelect">
          <td colspan="6" style="border:none">
            <el-col :span="2" style="text-align: right">数量：</el-col>
            <el-col :span="4">
              <el-input v-model="totalnumber" auto-complete="off" :required="true" style="width: 200px"></el-input>
            </el-col>
          </td>
        </tr>
        <tr  v-if="ADDlist.length>0">
          <td colspan="6" style="border:none">
            <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width: 70%" class="query-table">
              <tr>
                <td class="header" style="width:80px;">左/右</td>
                <td class="header" style="width:100px;">球镜</td>
                <td class="header" style="width:100px;">柱镜</td>
                <td class="header" style="width:80px;">轴位</td>
                <td class="header" style="width:150px;">ADD</td>
                <!--<td class="header" style="width:110px;">通道</td>-->
                <td class="header" style="width:100px;">数量</td>
              </tr>
              <tr v-for="item in tabledataADD">
                <td class="content">{{item.type}}
                </td>
                <td class="content">{{(item.Y>0?"+":"")+ parseFloat(item.Y).toFixed(2)}}
                </td>
                <td class="content">{{(item.X>0?"+":"")+ parseFloat(item.X).toFixed(2)}}
                </td>
                <td class="content">
                  <input v-model="item.A" style="width: 95%;padding: 0px;" :min="0" :max="10" v-on:change="range(item.A)"></input>
                </td>
                <td class="content">
                  <el-select v-model="item.ADD" filterable placeholder="请选择"  size="mini">
                    <el-option v-for="item in ADDlist" :key="item" :label="item" :value="item"></el-option>
                  </el-select>
                </td>
                <!--<td class="content">-->
                  <!--<el-select v-model="item.TD" filterable placeholder="请选择" @change="rangeTongdao" clearable>-->
                    <!--<el-option-->
                      <!--v-for="item in TDitem"-->
                      <!--:key="item.value"-->
                      <!--:label="item.label"-->
                      <!--:value="item.value">-->
                    <!--</el-option>-->
                  <!--</el-select>-->
                <!--</td>-->
                <td class="content">{{item.P}}</td>
              </tr>
              <!--<tr>-->
                <!--<td class="content">合计</td>-->
                <!--<td class="content" colspan="4"></td>-->
                <!--<td class="content"></td>-->
              <!--</tr>-->
            </table>
          </td>
        </tr>
        <tr class="noborder">
          <td>说&nbsp;&nbsp;&nbsp;&nbsp;明：</td>
          <td colspan="5">
            <textarea style="width: 100%;height: 60px" v-model="controlData.remark"></textarea>
          </td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button type="warning" plain size="mini" v-if="!IsBack&&ssotoken" @click="saveDataNotoken" style="float: left">确认采购（线下联系供应商下单）</el-button>
      <el-button @click="dialogSeeVisible = false">取 消</el-button>
      <el-button type="success" @click="delivergoodsScan" class="qrbtn" v-if="IsBack&&paramqrcodescan&&controlData.pcustomerserial&&controlData.cangkucode&&form.seedcode" :loading="loading">扫码</el-button>
      <el-button type="primary" @click="saveData" :loading="loading">{{IsBack?'生成退货单':'生成采购单'}}</el-button>
      <el-button type="warning" @click="importEdit" size="mini">二维表导入</el-button>
      <el-button type="warning" @click="importList" size="mini">列表导入</el-button>
      <a href="./static/file/镜片导入格式.xls">下载模板</a>
      <input type="file" ref="fileupload1" style="display: none;" @change="change1($event)"/>
    </div>
    <BuyorderDetail ref="BuyorderDetail"></BuyorderDetail>
    <BuyfromSupplyer ref="BuyfromSupplyer"></BuyfromSupplyer>
    <BuyfromEssilor ref="BuyfromEssilor" @afterEssilorBuy="afterEssilorBuy" :showTPD="true" :buytype="'buy'"></BuyfromEssilor>
    <QRCodeScan ref="QRCodeScan1" @scancodeedit="afterQRCodeScan"></QRCodeScan>
  </el-dialog>
</template>


<script>

  import {buyorderdetaillist,SSOrelatedOrder} from '@/api/set/csagreement';
  import BuyfromSupplyer from '../buyagreement/BuyfromSupplyer';
  import {login, createOrder,backOrder} from '@/api/ossi';
  import BuyfromEssilor from '@/components/testorder/buyagreement/BuyfromEssilor'
  import {suppliers} from '@/api/set/externaldept';
  import {getRemark} from '@/plugin/ordercommon'
  import {getGoodsTree} from '@/api/set/jxcgooddetail';
  import {getPrice} from '@/api/set/goodsprice';
  import TwoDimensionalTable from '@/components/set/goodsprice/TwoDimensionalTable';
  import BuyorderDetail from '../buyagreement/BuyorderDetail';
  import {getGoodsNeedBuy, getGoodsListWithStoreDetail} from '@/api/set/jxcresultstore';
  import {checkModuleRight} from '@/api/login'
  import {bardetail} from '@/api/set/jxcgoodsbarcode'
  import {saveData as saveLogData} from '@/api/set/handlelog';
  import QRCodeScan from './QRCodeScan';

  import {
    getCstagreementListDataNew,
    cstagreementDeleteData,
    cstagreementUpdateData,
    buyodersavedetail, jxcstorelist, getpcustomerserial
  } from '@/api/set/csagreement';

  import {getDetail} from '@/api/set/jxcgooddetail'
  import {getListData} from '@/api/set/jxcstore'
  import {cusandptbyind} from '@/api/set/jxcstore';

  export default {
    name: 'BuyorderDetailEdit',
    data() {
      let yearnow = new Date().getFullYear()
      let monthnow = new Date().getMonth() + 1
      return {
        ssotoken:"",
        mySystem:false,
        website:"",
        IsBack:false,
        isgift:false,
        loading:false,
        tabledataADD:[],
        userInfoModel:{},
        book: {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []},
        erweitable: [],//二维表
        erweitableleft: [],//左眼二维表
        erweitableright: [],//右眼二维表
        storeinfo: [],//库存信息
        storeinforight: [],//右库存信息
        storeinfoleft: [],//左库存信息
        intelligentstore: false,
        costpricebook: {},
        ADDlist:[],
        auditbuyorder:'2',
        dialogFormVisible: false,
        title: "",
        BookContent: [],
        BookContentLeft: [],
        BookContentRight: [],
        index: -99,
        seedgoods: [],
        dialogSeeVisible: false,
        formLabelWidth: '120px',
        groupguid: '',
        maxyear: yearnow,
        maxmonth: monthnow,
        remark: '',
        cangkucode: '',
        cangkuname: '',
        tableData: [
          {column: []},
        ],
        unitguid: "",
        subnumber:0,
        column: [],
        ptableData: [],
        controlData: {},
        storenumtable: [],
        showtitle1: "none",
        jxcstoreData: [],
        filltemplate: "",
        showzuoyoutable: false,
        showerweitable: false,
        showNumberSelect: false,//数量选择
        totalnumber: '',
        ADDString:'',
        form: {  //表单数据
          unitguid: "",
          bookstr: "",
          seedcode: "",
          seedname: "",
          seedinfo: "",
        },
        isRightStr:'',
        tracknum: '',//供应商单号
        logisticstracknum: '',//跟踪单号
        scanpowercode:'',
        transitionArr:[],
        paramqrcodescan:false,
        loadbylist:false,
      }

    },
    methods: {
      selectADD() {
        for (let i in this.tabledataADD) {
          this.tabledataADD[i].ADD = this.ADDString;
        }
      },
      afterChangeLeft(item) {
        this.afterChange(item, "L")
      },
      afterChangeRight(item) {
        this.afterChange(item, "R")
      },
      afterChange(item,type) {
        if (!this.ADDlist || this.ADDlist.length == 0) return;
        let biaoji = 0
        if (type == null) type = '';
        for (let i in this.tabledataADD) {
          if (this.tabledataADD[i].type == type && this.tabledataADD[i].X == item.X && this.tabledataADD[i].Y == item.Y) {
            if (item.P && parseFloat(item.P) != 0) {
              this.tabledataADD[i].P = item.P
            } else {
              this.tabledataADD.splice(i, 1)
            }
            biaoji = 1
            break
          }
        }
        if (biaoji == 0 && item.P != 0) {//新增
          this.tabledataADD.push({X: item.X, Y: item.Y, P: item.P, A: '', ADD: this.ADDString, type: type})
        }
      },
      //扫光度码（扫码后增加二维表对应光度的数量）
      scanPowerCode() {
        if (!this.scanpowercode)
          return;
        const _this = this;
        bardetail({barcode: this.scanpowercode}).then(response => {
          _this.scanpowercode = '';
          if (!response.data.obj || response.data.code != 0 || !response.data.obj.seedcode) {
            _this.$message({ message: '光度码无效！', type: 'error' });
            _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
            return;
          }
          const obj = response.data.obj;
          const seedcode = obj.seedcode;
          // 检查商品编码是否匹配
          if (seedcode != _this.form.seedcode) {
            _this.$message({ message: '商品编码不匹配！当前商品：' + _this.form.seedname, type: 'warning' });
            _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
            return;
          }
          // 解析光度码的packagesize获取球镜(Y)和柱镜(X)
          let packagesizeObj;
          try {
            packagesizeObj = JSON.parse(obj.packagesize || '{}');
          } catch (e) {
            _this.$message({ message: '光度码数据格式错误', type: 'error' });
            _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
            return;
          }
          const Y = parseFloat(packagesizeObj.Y) || 0;
          const X = parseFloat(packagesizeObj.X) || 0;
          let matched = false;
          // 在二维表中查找匹配的单元格并增加数量
          if (_this.showerweitable && _this.erweitable) {
            for (let i in _this.erweitable) {
              for (let j in _this.erweitable[i]) {
                const cell = _this.erweitable[i][j];
                if (cell.Y == Y && cell.X == X) {
                  cell.P = (parseInt(cell.P) || 0) + 1;
                  // 同步到tabledataADD
                  let found = false;
                  for (let k in _this.tabledataADD) {
                    if (_this.tabledataADD[k].X == X && _this.tabledataADD[k].Y == Y && !_this.tabledataADD[k].type) {
                      _this.tabledataADD[k].P = cell.P;
                      found = true;
                      break;
                    }
                  }
                  if (!found && cell.P > 0) {
                    _this.tabledataADD.push({X: X, Y: Y, P: cell.P, A: '', ADD: _this.ADDString, type: ''});
                  }
                  matched = true;
                  break;
                }
              }
              if (matched) break;
            }
          }
          // 左右眼模式
          if (_this.showzuoyoutable) {
            const type = packagesizeObj.type || '';
            const targetTable = type == 'L' ? _this.erweitableleft : _this.erweitableright;
            const targetType = type == 'L' ? 'L' : 'R';
            if (targetTable) {
              for (let i in targetTable) {
                for (let j in targetTable[i]) {
                  const cell = targetTable[i][j];
                  if (cell.Y == Y && cell.X == X) {
                    cell.P = (parseInt(cell.P) || 0) + 1;
                    let found = false;
                    for (let k in _this.tabledataADD) {
                      if (_this.tabledataADD[k].X == X && _this.tabledataADD[k].Y == Y && _this.tabledataADD[k].type == targetType) {
                        _this.tabledataADD[k].P = cell.P;
                        found = true;
                        break;
                      }
                    }
                    if (!found && cell.P > 0) {
                      _this.tabledataADD.push({X: X, Y: Y, P: cell.P, A: '', ADD: _this.ADDString, type: targetType});
                    }
                    matched = true;
                    break;
                  }
                }
                if (matched) break;
              }
            }
          }
          if (!matched) {
            _this.$message({ message: '未在二维表中找到匹配的光度(' + Y + ', ' + X + ')', type: 'warning' });
          }
          _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
        }).catch(() => {
          _this.scanpowercode = '';
          _this.$message({ message: '光度码查询失败', type: 'error' });
          _this.$nextTick(() => { _this.$refs.scanpowerInput.focus(); });
        });
      },
      delivergoodsScan() {//扫码发货
        this.$refs.QRCodeScan1.show({
          cangkucode: this.controlData.cangkucode,
          erpserial: this.controlData.erpserial,
          seedcode: this.form.seedcode
        }, true);
      },
      afterQRCodeScan(scancodes) {//扫码后提交(退货时才有)
        var arr = []
        var setV=[];

        for(let i in scancodes){
          var pg=scancodes[i].packagesize;
          var seedcode=scancodes[i].seedcode;
          if(setV.indexOf(pg+seedcode)>-1)
            continue;

          var datas=scancodes.filter(sitem => {
            return sitem.packagesize === pg&&sitem.seedcode === seedcode;
          });
          var item=JSON.parse(pg);
          item.P=-datas.length;
          arr.push(item);
          setV.push(pg+seedcode);
        }
        this.postBuyData(arr, '保存成功！',null,true);
      },
      importList(){
        this.loadbylist=true;
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      //导入二维表
      importEdit() {
        this.loadbylist=false;
        this.$refs.fileupload1.value = ""
        this.$refs.fileupload1.click()
      },
      change1(event) {
        try {
          var reg = /(\.xls|\.xlsx)$/
          if (!reg.test(event.target.files[0].name)) {
            this.$message.error("只能导入.xls或者.xlsx的文件！")
            return
          }
          this.$importExcel(event.target.files[0], (data) => {
            let arr = []
            if (typeof data == "object" && (Array.isArray(data) || obj1 instanceof Array)) {
              let obj = {}
              if(this.loadbylist) {
                data.forEach((item) => {
                  var pg = JSON.parse(item['光度']);
                  pg.P = parseInt(item['数量']);
                  arr.push(pg)
                })
              }else {
                data.forEach((item) => {
                  let Y = ""
                  for (let X in item) {
                    obj = {}
                    if (X == "球\\柱") {
                      Y = parseFloat(item[X]).toFixed(2)
                    } else {
                      if (typeof parseFloat(item[X]) === 'number' && !isNaN(parseFloat(item[X]))) {
                        obj = {"X": parseFloat(X).toFixed(2), "Y": Y, "P": Math.abs(parseFloat(item[X]))}
                        if (this.type) {
                          obj.type = this.type
                        }
                        arr.push(obj)
                      }
                    }
                  }
                })
              }
            }
            this.BookContent = arr
            this.createPriceBook()
          })
        } catch (ee) {
          this.$message.error("导入失败")
        }
      },
//绑定库存
      bindStore() {
        let yearnow = new Date().getFullYear()
        let monthnow = new Date().getMonth() + 1
        this.storeinfoleft = [];
        this.storeinforight = [];
        this.storeinfo = [];

        getGoodsListWithStoreDetail({
          seedcode: this.form.seedcode,//
          minyear: yearnow,
          minmonth: monthnow,
          maxyear: yearnow,
          maxmonth: monthnow,
          nostock: 1,
          cangkucode: this.controlData.cangkucode,
          calculateStore: "1"
        }).then(resStore => {
          if (resStore.data.obj.length > 0) {
            resStore.data.obj.forEach(o => {
              if (o.packagesize) {
                let ob = JSON.parse(o.packagesize)
                ob.P = o.subtractnum - o.deliverying;// + o.transfernum;
                if (ob.type == 'L') {
                  this.storeinfoleft.push(ob);
                } else if (ob.type == "R") {
                  this.storeinforight.push(ob);
                } else {
                  this.storeinfo.push(ob);
                }
              }
            })
          } else {

          }
          this.createPriceBook()
        }).catch((error) => {
          console.log(error)
        });


      },
      getTitle() {
        let result = this.userInfoModel.tenantname || ""
        result += "采购订单"
        return result
      },
      initnum() {
        if (this.form.seedcode && this.intelligentstore) {
          getGoodsNeedBuy({seedcode: this.form.seedcode, cangkucode: this.controlData.cangkucode}).then(response => {
            for (let i in response.data.obj) {
              let packagesize = JSON.parse(response.data.obj[i]["packagesize"])
              packagesize["P"] = response.data.obj[i]["maxstore"]
              if (this.showzuoyoutable) {//左右眼
                if (packagesize["type"] == "L") {
                  this.BookContentLeft.push(packagesize)
                } else if (packagesize["type"] == "R") {
                  this.BookContentRight.push(packagesize)
                }
              } else if (this.showerweitable) {
                this.BookContent.push(packagesize)
              } else if (this.showNumberSelect) {

              }
            }
            if (!this.showNumberSelect)
              this.getXYRange()
          }).catch((error) => {
            console.log(error)
          });
        } else {
          this.$message({
            message: '请选择货品',
            type: 'info'
          })
        }
      },
      changepcu(val) {
        for (let i in this.ptableData) {
          if (this.ptableData[i].customerserial == val) {
            this.controlData.pcustomerserial = this.ptableData[i].customerserial
            this.controlData.pcustomer = this.ptableData[i].deptname
            this.controlData.clinkman = this.ptableData[i].linkman
            this.controlData.clinkmantel = this.ptableData[i].linkmantel
            this.controlData.caddress = this.ptableData[i].address
            this.BookContent = []
          }
        }
        if (val) {
          this.getXYRange()
        }
      },
      checktree1(guids, names, arr) {
        this.form.seedcode = guids
        this.form.seedname = names
        this.form.seedinfo = ";" + guids + "," + arr[0].parentId + ";"
        this.filltemplate = arr[0].attributes.filltemplate
        this.costpricebook = {}
        this.BookContent = []
        this.BookContentLeft = []
        this.BookContentRight = []
        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
        if (this.filltemplate == '30') {//显示左右眼table
          this.showzuoyoutable = true
          this.showerweitable = false
          this.showNumberSelect = false
        } else if (this.filltemplate == '10' || this.filltemplate == '20') {//显示现片定制片下单
          this.showzuoyoutable = false
          this.showerweitable = true
          this.showNumberSelect = false
        } else if (this.filltemplate == '40') {
          this.showzuoyoutable = false
          this.showerweitable = false
          this.showNumberSelect = true
        }

        if (this.form.seedname == "") {
          this.$message({
            message: '请选择货品',
            type: 'warning'
          })
          return
        }

        this.geterweibiao()
      },
      //判断是否有供应商
      geterweibiao() {
        this.ptableData=[]
        var tenID= this.userInfoModel.tenantid;
        suppliers({seedcodes: '["' + this.form.seedcode + '"]', search: ""}).then((response) => {
          for(let i in response.data.obj) {
            var row = response.data.obj[i]
            this.ptableData.push(row);
          }

          if (this.ptableData.length > 0) {
            this.controlData.pcustomerserial = this.ptableData[0].customerserial
            this.controlData.pcustomer = this.ptableData[0].deptname
            this.controlData.clinkman = this.ptableData[0].linkman
            this.controlData.clinkmantel = this.ptableData[0].linkmantel
            this.controlData.caddress = this.ptableData[0].address
            this.getXYRange()
          }
        })
      },
      bindData() {
        this.$refs.treeSeed.bindData(() => {
          return getGoodsTree({nostock: 1,filltemplates:'10;20;30;40'})
        })
      },
      getXYRange() {
        this.ssotoken="";
        this.mySystem=false;
        this.ADDlist=[];
        this.ADDString="";
        this.tabledataADD=[];
        if (!this.controlData.pcustomerserial)
          return;

        //根据供应商取价格范围
        getPrice({
          seedcode: this.form.seedcode,
          customerSerial: this.controlData.pcustomerserial,
          filterType: 'cost'
        }).then((response) => {
          if (response.data.code == 0 && response.data.obj) {
            this.costpricebook = response.data.obj
            if (response.data.obj.formproperty && !this.IsBack) {
              try {
                var formprop = JSON.parse(response.data.obj.formproperty);
                for (let i in formprop) {
                  if (formprop[i].name == 'ADD') {
                    var items = formprop[i].item.split(';')
                    for (let s in items) {
                      if (items[s]) {
                        this.ADDlist.push(items[s]);
                      }
                    }
                  }
                }
                if (this.ADDlist.length == 1)
                  this.ADDString = this.ADDlist[0];
              } catch (e) {}
            }
          }else {
            this.costpricebook = {}
          }
          var usesso=response.data.obj.dept.usesso;

          if((usesso==1||usesso==2)&&response.data.obj.dept.ssocode) {
            if (response.data.obj.dept.ssocode.indexOf("supplier") > -1) {//直接向供应商采购
              this.ssotoken = response.data.obj.dept.ssocode;
            } else {
              this.mySystem=usesso==2;
              login({
                idencode: response.data.obj.dept.ssocode,
                tenantid: this.userInfoModel.tenantid
              },this.mySystem).then(loginres => {
                if (loginres.data.code == 0) {
                  this.ssotoken = loginres.data.msg;
                  this.website = loginres.data.website;
                } else {
                  this.$message({message: '订单接口异常！', type: 'error'})
                  this.ssotoken = loginres.data.msg;
                }
              });
            }
          }
          //绑定库存
          this.bindStore()
        })

      },
      createPriceBook() {
        if (this.filltemplate == 30) {
          this.$refs.referweibiaoleft.initBook(this.costpricebook, this.BookContentLeft, '', this.storeinfoleft)
          this.$refs.referweibiaoright.initBook(this.costpricebook, this.BookContentRight, '', this.storeinforight)
        } else {
          this.$refs.referweibiao.initBook(this.costpricebook, this.BookContent, '', this.storeinfo)
        }
      },
      getLiuYan(remark) {
        return getRemark(remark);
      },
      print1() {
        // window.print()
        this.showtitle1 = ""
        this.$nextTick(() => {
          this.$print(this.$refs.print1)

          this.showtitle1 = "none"
        })
      },
      show() {
        this.dialogSeeVisible = true;
      },
      changename(val) {
        for (let i in this.jxcstoreData) {
          if (this.jxcstoreData[i].cangkucode == val) {
            this.controlData.cangkuname = this.jxcstoreData[i].cangkuname;
          }
        }
        this.BookContent = []
        if (this.form.seedcode) {
          this.bindStore()
        }
        // this.createPriceBook()
      },
      contains(item, arr) {
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] == item) {
            return true;
          }
        }
        return false;
      },
      getRemark(remark) {
        if (remark) {
          try {
            let temp = JSON.parse(remark)
            temp.forEach(item => {
              if (item.type == "客户留言") {
                return item.msg
              }
            })
          } catch (ex) {
          }
        }
        return ""
      },
      saveDataNotoken() {
        this.saveData('notoken');
      },
      saveData(notoken) {
        //取出对应的表单详情和数量
        this.loading = true;
        if (notoken && notoken == 'notoken') {
          this.ssotoken = "";
          this.mySystem = false;
        }
        var arr = [];
        if (this.showzuoyoutable) {//左右眼
          for (let i in   this.erweitableleft) {
            let temp = this.erweitableleft[i].filter((t) => {
              t.type = "L"
              return typeof(t.P) != "undefined" && parseInt(t.P) > 0;
            })
            arr = arr.concat(temp)
          }
          for (let i in   this.erweitableright) {
            let temp = this.erweitableright[i].filter((t) => {
              t.type = "R"
              return typeof(t.P) != "undefined" && parseInt(t.P) > 0;
            })
            arr = arr.concat(temp)
          }
        }
        else if (this.showerweitable) {//非左右眼
          for (let i in   this.erweitable) {
            let temp = this.erweitable[i].filter((t) => {
              return typeof(t.P) != "undefined" && parseInt(t.P) > 0;
            })
            arr = arr.concat(temp)
          }
        } else {
          if (parseInt(this.totalnumber) > 0) {
            arr.push(
              {
                P: this.totalnumber
              }
            )
          } else {
            this.$message({
              message: '未输入数量！',
              type: 'warning'
            })
            this.loading = false;
            return
          }
        }

        if (!this.controlData.pcustomerserial) {
          this.$message({
            message: '请选择供应商！',
            type: 'warning'
          })
          this.loading = false;
          return
        }
        if (!this.controlData.cangkucode) {
          this.$message({
            message: '请选择仓库！',
            type: 'warning'
          })
          this.loading = false;
          return
        }
        this.subnumber = 0;
        var buyFormsArr = []
        if (this.ADDlist.length > 0) {
          var arr = [];
          for (let i in this.tabledataADD) {
            if (!this.tabledataADD[i].ADD) {
              this.$message({
                message: '请选择ADD！',
                type: 'warning'
              })
              this.loading = false;
              return
            }

            var buyFormsItem = {"seedcode": this.form.seedcode, "seedname": this.form.seedname};
            var arrItem={};
            if(this.tabledataADD[i].type){
              arrItem.type=this.tabledataADD[i].type
              buyFormsItem["type"] =arrItem.type;
            }
            arrItem.X=this.tabledataADD[i].X;
            arrItem.Y=this.tabledataADD[i].Y;
            arrItem.P=this.tabledataADD[i].P;
            arrItem.formproperty = '[{"ADD":"' + this.tabledataADD[i].ADD + '","A":"' + this.tabledataADD[i].A + '"}]';
            if (this.IsBack) {
              arrItem.P = -arrItem.P;
            }
            arr.push(arrItem);

            buyFormsItem["X"] = arrItem.X;
            buyFormsItem["Y"] = arrItem.Y;
            buyFormsItem["Number"] = arrItem.P;
            buyFormsItem["ADD"] = this.tabledataADD[i].ADD;
            buyFormsItem["A"] = this.tabledataADD[i].A;
            buyFormsArr.push(buyFormsItem);
            this.subnumber += parseInt(arrItem.P);
          }
        }else {
          for (let j in arr) {
            var buyFormsItem = {"seedcode": this.form.seedcode, "seedname": this.form.seedname};
            if (arr[j].type)
              buyFormsItem["type"] = arr[j].type;
            if (arr[j].X || arr[j].X == 0)
              buyFormsItem["X"] = parseFloat(arr[j].X).toFixed(2).toString();
            if (arr[j].Y || arr[j].Y == 0)
              buyFormsItem["Y"] = parseFloat(arr[j].Y).toFixed(2).toString();
            if (this.ADDString) {
              arr[j].formproperty = '[{"ADD":"' + this.ADDString + '"}]';
              buyFormsItem["ADD"] = this.ADDString.toString();
            }
            if (this.IsBack) {
              arr[j].P = -arr[j].P;
            }
            buyFormsItem["Number"] = arr[j].P;
            buyFormsArr.push(buyFormsItem);

            this.subnumber += parseInt(arr[j].P);
          }
        }
        if (arr.length == 0) {
          this.$message({
            message: '未输入数量！',
            type: 'warning'
          })
          this.loading = false;
          return
        }

        var buyForms = JSON.stringify(buyFormsArr);

        if (!this.IsBack & !this.isgift && this.ssotoken && this.ssotoken.indexOf("supplier") > -1) {
          this.transitionArr = arr;
          this.$refs.BuyfromEssilor.show(this.ssotoken, buyForms, this.controlData);
          this.loading = false;
        } else if (!this.IsBack & !this.isgift && this.ssotoken) {//需要向供应商发起采购
          var ckInfo = {};
          for (let i in this.jxcstoreData) {
            if (this.jxcstoreData[i].cangkucode == this.controlData.cangkucode) {
              ckInfo = this.jxcstoreData[i];
            }
          }
          var ssodirectsend = null
          if (this.ssotoken && this.ssotoken.indexOf('http') > -1) {
            ssodirectsend = {
              linkman: ckInfo.applyby, linkmantel: ckInfo.tel, deliveryaddress: ckInfo.adressdetail
            };
          }
          createOrder({
            parentguid: '',
            uname: this.userInfoModel.uname,
            uguid: this.userInfoModel.uguid,
            linkman: ckInfo.applyby,
            linkmantel: ckInfo.tel,
            deliverymode: '配送',
            deliveryaddress: ckInfo.adressdetail,
            ssodirectsend: ssodirectsend ? JSON.stringify(ssodirectsend) : "",
            formproperty: buyForms,
            remark: '[{"msg":"' + (this.controlData.remark ? this.controlData.remark : '') + '","date":"' + this.CurentTime() + '","uname":"' + this.userInfoModel.uname + '","type":"客户留言"}]',
          }, this.ssotoken, this.mySystem).then(response => {
            if (response.data.price) {
              // var priceList = response.data.price;//{商品编码:价格} 只有一个商品
              // for (let j in arr) {
              //   arr[j].gysprice = priceList[this.form.seedcode]
              // }
            }

            if (response.data.code == 0) {
              this.tracknum = response.data.erpserial;
              this.postBuyData(arr, '上游订单已生成，供应商单号：' + this.tracknum,null,null,response.data.buyerpserial);
            } else {
              if (response.data.groupguid) {//打开支付页面
                this.$confirm(response.data.msg, '提示', {
                  confirmButtonText: '生成订单并支付',
                  cancelButtonText: '暂不生成',
                  showClose: false,
                  type: 'warning'
                }).then(() => {
                  this.tracknum = response.data.erpserial;
                  this.postBuyData(arr, '上游订单已生成，供应商单号：' + this.tracknum + '，请尽快完成支付！');
                  this.$refs.BuyfromSupplyer.show(this.ssotoken, this.website, response.data, 'pay');
                }).catch(() => {
                  //撤销订单
                  backOrder({erpserial: response.data.erpserial.split(';')[0]}, this.ssotoken, this.mySystem).then(resDel => {
                    this.loading = false
                  });
                });
              } else {
                this.$message({
                  message: response.data.msg ? response.data.msg : '提交的商品不存在！',
                  type: 'error'
                })
                this.loading = false
              }
            }
          });
        } else {
          this.postBuyData(arr, '保存成功！');
        }
      },
      afterEssilorBuy(buyInfo) {
        this.postBuyData(this.transitionArr, '提交成功！', buyInfo);
      },
      postBuyData(arr,msg,supplydetail,saveQRcode,buyerpserial) {
        buyodersavedetail({
          jxcforms: JSON.stringify(arr),
          map: JSON.stringify({
            pcustomerserial: this.controlData.pcustomerserial,
            pcustomer: this.controlData.pcustomer,
            cangkuname: this.controlData.cangkuname,
            cangkucode: this.controlData.cangkucode,
            address: this.controlData.address,
            linkman: this.controlData.linkman,
            linkmantel: this.controlData.linkmantel,
            seedcode: this.form.seedcode,
            seedname: this.form.seedname,
            seedinfo: this.form.seedinfo,
            remark: this.controlData.remark ? this.controlData.remark : '',
            tracknum: this.tracknum.trim(),//供应商单号
            logisticstracknum: this.logisticstracknum.trim(),//跟踪单号
            invoicesource: this.auditbuyorder,//待审核
            isgift: this.isgift ? 1 : -1,
            righttype: this.isRightStr,
            buyerpserial:buyerpserial,
            status: 810,
          }),
          supplydetail: supplydetail
        }).then(response => {
          if (response.data.code == 0) {
            if (this.ssotoken&&!buyerpserial&& this.ssotoken.indexOf("supplier") == -1) {
              SSOrelatedOrder({
                erpserial: this.tracknum.trim(), parenterpserial: response.data.obj.erpserial, uname: '采购号'
              }, this.ssotoken, this.mySystem).then(response => {
              })
            }
            if (this.IsBack&&saveQRcode&&this.$refs.QRCodeScan1) {//退货出库的时候需要保存 唯一码
              this.$refs.QRCodeScan1.saveQRCode(response.data.obj.erpserial);
            }
            this.$message({
              message: msg,
              type: 'success'
            })
            this.$emit('bindGrid');

            //记录日志
            var handlelog = {}
            handlelog.erpserial = response.data.obj.erpserial
            handlelog.isopen = 1
            handlelog.insub = 1;
            handlelog.totalnumber = this.subnumber;
            handlelog.casestepname = '录入采购单'
            handlelog.remark = ''
            saveLogData(handlelog).then(response => {
            });
            //this.lookbuyorderdetail(response.data.obj, 1)
          } else {
            this.$message({
              message: response.data.msg,
              type: 'error'
            })
          }
          this.dialogSeeVisible = false;
          //刷新列表
        });
      },
      //查看采购单
      lookbuyorderdetail(row, isbuyorder) {
        this.$refs.BuyorderDetail.initData(row, isbuyorder)
        this.$refs.BuyorderDetail.show();
      },
      CurentTime()
      {
        var now = new Date();

        var year = now.getFullYear();       //年
        var month = now.getMonth() + 1;     //月
        var day = now.getDate();            //日

        var hh = now.getHours();            //时
        var mm = now.getMinutes();          //分

        var clock = year + "-";

        if(month < 10)
          clock += "0";

        clock += month + "-";

        if(day < 10)
          clock += "0";

        clock += day + " ";

        if(hh < 10)
          clock += "0";

        clock += hh + ":";
        if (mm < 10) clock += '0';
        clock += mm;
        return(clock);
      },
      initData(row,IsBack) {
        this.initForm();
        this.ptableData = [];
        this.IsBack=IsBack;

        if (row == null)
          return;

        this.controlData.cangkucode = row.cangkucode;
        this.controlData.cangkuname = row.cangkuname;

        this.index = -99
        this.addvisible = true
        if (row) {
          getDetail({seedcode: row.seedcode}).then(response => {
            this.filltemplate = response.data.obj.filltemplate
            this.form.seedcode = response.data.obj.seedcode
            this.form.seedname = response.data.obj.seedname
            if (this.filltemplate == '30') {//显示左右眼table
              this.showzuoyoutable = true
              this.showerweitable = false
              this.showNumberSelect = false
            } else if (this.filltemplate == '10' || this.filltemplate == '20') {//显示现片定制片下单
              this.showzuoyoutable = false
              this.showerweitable = true
              this.showNumberSelect = false
            } else if (this.filltemplate == '40') {
              this.showzuoyoutable = false
              this.showerweitable = false
              this.showNumberSelect = true
            }
            this.geterweibiao()
            this.initnum()
          })
        }
        // });
      },
      initForm() {
        this.controlData = {cangkucode: this.controlData.cangkucode,cangkuname: this.controlData.cangkuname}
        this.groupguid = ""
        this.column = []
        this.isgift=false
        this.loading=false;
        this.mySystem=false;
        this.ssotoken=""
        this.tableData = []
        this.unitguid = ""
        this.BookContent = []
        this.BookContentLeft = []
        this.BookContentRight = []
        this.showzuoyoutable = false
        this.showerweitable = false
        this.showNumberSelect = false
        this.filltemplate = ""
        this.totalnumber = '';
        this.tracknum = ''
        this.logisticstracknum = ''
        this.scanpowercode = ''
        this.costpricebook = ""
        this.form.bookstr = ""
        this.form.seedcode = ""
        this.isRightStr="";
        this.ADDString='';
        this.ADDlist=[];
        this.tabledataADD=[];
        this.form.seedname = ""
        this.form.seedinfo = ""
        this.book = {XStart: 0, XEnd: 0, XSpace: 0, YStart: 0, YEnd: 0, YSpace: 0, BookContent: []}
        this.erweitable = []

        if (this.$refs.referweibiao) {
          this.$refs.referweibiao.initForm()
        }
        if (this.$refs.referweibiaoleft) {
          this.$refs.referweibiaoleft.initForm()
        }
        if (this.$refs.referweibiaoright) {
          this.$refs.referweibiaoright.initForm()
        }
      }
    },
    mounted() {
      let temp = localStorage.getItem("hpapi_userInfoModel")
      if (temp) {
        this.userInfoModel=JSON.parse(temp);
      }

      checkModuleRight({name: 'intelligentstore'}).then(reponse => {
        this.intelligentstore = reponse.data.code == 0;
      });
      checkModuleRight({name: 'auditbuyorder'}).then(reponse => {//采购单需要审核
        this.auditbuyorder = reponse.data.code == 0?'1':'2';
      });
      checkModuleRight({name: 'qrcodescan'}).then(reponse => {//允许使用扫码发货
        this.paramqrcodescan = reponse.data.code == 0;
      });

      cusandptbyind().then(response => {
        this.jxcstoreData = response.data.obj
        this.controlData.cangkucode = this.jxcstoreData[0].cangkucode;
        this.controlData.cangkuname = this.jxcstoreData[0].cangkuname;
      })
    },
    components: {
      TwoDimensionalTable,
      BuyorderDetail,
      BuyfromSupplyer,
      BuyfromEssilor,
      QRCodeScan
    }
  }
</script>

<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }

  .gray1 td {
    color: #C0C4CC;
    background-color: #ebeef5;
  }

  .gray1 input {
    display: none;
  }

</style>





// WEBPACK FOOTER //
// src/components/testorder/buyagreement/BuyorderDetailEdit.vue